import React from "react";
import styles from "../Footer2/Footer2.module.css";
import { useNavigate, useLocation } from "react-router-dom";
const FooterBottom = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isEdofPage = location.pathname === "/edof"; //
  return (
    <div>
      <div className={styles.footerBottom}>
        <div className={styles.footerColumn}>
          <img
            loading="lazy"
            src="/Images/Logo-svg2.png"
            alt="Bruno Vision Care logo"
            className={styles.logo}
           decoding="async" />
        </div>

        <div className={styles.footerLinks}>
          <div>
            <ul>
              <li onClick={() => navigate("/for-professionals")}>
                For Professionals
              </li>
            </ul>
            <ul>
              <li onClick={() => navigate("/for-patients")}>For Patients</li>
            </ul>
            {!isEdofPage && (
              <ul>
                <li onClick={() => navigate("/edof")}> Innovation</li>
              </ul>
            )}

            <ul>
              <li onClick={() => navigate("/news-room")}>Newsroom</li>
            </ul>
          </div>
          <div>
            <ul>
              <li onClick={() => navigate("/about-us")}>About Us</li>
              <li onClick={() => navigate("/our-company")}>Our Company</li>

              <li onClick={() => navigate("/sustainability")}>
                Sustainability
              </li>
              <li onClick={() => navigate("/contact-us")}>Contact Us</li>
            </ul>
          </div>

          <div>
            <ul>
              <li>
                <a href="/termsofuse" target="_blank" rel="noopener noreferrer">
                  Terms of Use
                </a>
              </li>
              <li>
                <a
                  href="/privacy-and-cookie-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy and Cookie Policy
                </a>
              </li>
              <li onClick={() => navigate("/ifu")}>IFU</li>
            </ul>
          </div>
        </div>
      </div>

      <div className={styles.copyRight}>
        <p>©2024 Bruno Vision Care. All rights reserved </p>
      </div>
    </div>
  );
};

export default FooterBottom;
